import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'
import TestActions from '@/Components/custom/test-actions'

export default function TezNet() {
  const blocks = useBlockRenderer('teznet') as Block[]

  return (
    <>
      <BlockRenderer blocks={blocks} />
      <TestActions />
    </>
  )
}
